import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProblemsSection from './components/ProblemsSection';
import SolutionsSection from './components/SolutionsSection';
import CoreTruthsSection from './components/CoreTruthsSection';
import PositioningSection from './components/PositioningSection';
import CTASection from './components/CTASection';
import ChecklistDownloadSection from './components/ChecklistDownloadSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <ProblemsSection />
      <SolutionsSection />
      <ChecklistDownloadSection />
      <CoreTruthsSection />
      <PositioningSection />
      <CTASection />
      <Footer />
    </div>
  );
}